import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#E7E8E9',
    },
    secondary: {
      main: '#9F6D47',
    },
    background: {
      default: '#101820',
      paper: '#101820',
    },
    text: {
      primary: '#E7E8E9',
      secondary: '#9F6D47',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h1: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    h2: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    h3: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    h4: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    h5: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    h6: {
      color: '#E7E8E9',
      fontWeight: 500,
    },
    body1: {
      color: '#E7E8E9',
    },
    body2: {
      color: '#9F6D47',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#101820',
          backgroundImage: 'none',
          borderColor: '#9F6D47',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#9F6D47',
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#E7E8E9',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: 'rgba(231, 232, 233, 0.2)',
          },
        },
      },
    },
  },
});

function App() {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
              <img 
                src="/logo-white.png" 
                alt="Seekr Logo" 
                style={{ height: '32px', marginRight: '12px' }} 
              />
              <Typography variant="h6" component="div" sx={{ fontWeight: 500 }}>
                Seekr App
              </Typography>
            </Box>
            <Button color="inherit" onClick={() => navigate('/support')}>Contact & Support</Button>
            <Button color="inherit" onClick={() => navigate('/privacy-policy')}>Privacy Policy</Button>
            <Button color="inherit" onClick={() => navigate('/terms')}>Terms & Conditions</Button>
          </Toolbar>
        </AppBar>
      </Box>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Routes>
          <Route path="/support" element={<Support />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/" element={<Support />} />
        </Routes>
        <Box 
          component="footer" 
          sx={{ 
            mt: 6, 
            pt: 3, 
            pb: 3, 
            borderTop: '1px solid #9F6D47',
            textAlign: 'center'
          }}
        >
          <Typography variant="body2" sx={{ color: '#E7E8E9' }}>
            © 2025 Seekr. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default App;